import _ from 'lodash'
import { computeDisplayedTablePots } from './computeDisplayedTablePots'
import {
  UserGameHandState,
  buildUserGameHandStates,
} from '../sharedBetweenServerAndClient__DO_NOT_EDIT/AbstractGameHandController/buildUserGameHandStates'
import { Logger, ID, Model } from '../sharedBetweenServerAndClient__DO_NOT_EDIT/types'
import { AbstractGameHandController } from '../sharedBetweenServerAndClient__DO_NOT_EDIT/AbstractGameHandController/AbstractGameHandController'
import { IPositionProps, IUserPositioning } from '../page/GameDetails/positionProps'
import { logger } from '../utils/logger'

export interface IClientUserData extends Model.User, UserGameHandState, IUserPositioning {
  role?: Model.UserRole
  totalAmountGiven: number
}

export class ClientGameHandController extends AbstractGameHandController {
  private userData: IClientUserData[]
  private userDataMap: _.Dictionary<IClientUserData>
  public totalChips: number
  public pots: number[]

  constructor(
    public gameHand: Model.GameHand,
    public currentUserId: string,
    public users: Model.User[],
    public game: Model.Game,
    public positionProps: IPositionProps,
    public currentUserHand?: Model.UserHand,
  ) {
    super(gameHand, currentUserId)
    const userMap = _.keyBy(users, (user) => user.id)
    this.totalChips = _.sum(_.values(gameHand.chipsAtStartOfHand)) + gameHand.leftoverWinningsAmount
    this.userData = this.gameHand.userTablePosition.map((userId) => {
      return {
        ...userMap[userId],
        ...this.userStateMap[userId],
        role: this.game.userRoles[userId],
        totalAmountGiven: this.game.totalChipsGiven[userId],
        ...(userId === currentUserId
          ? positionProps.currentUserTablePositioning
          : positionProps.otherUserPositioning[
              this.otherUsersTablePosition.findIndex((positionUserId) => positionUserId === userId)
            ]),
      }
    })
    this.userDataMap = _.keyBy(this.userData, (data) => data.id)
    logger.debug('current userData:', 'ClientGameHandController', this.userData)
    this.pots = computeDisplayedTablePots(_.values(this.userStateMap))
  }

  getUserData(userId: ID) {
    return this.userDataMap[userId]
  }

  get currentUserData() {
    return this.userDataMap[this.currentUserId]
  }
}
